import * as CookiesStatic from 'js-cookie';
import { action, observable, runInAction, makeObservable } from 'mobx';
import { eAccessControlLogoutReason } from 'ui-toolkit/enums/eAccessControlLogoutReason';
import { clientUrls } from 'ui-toolkit/rest/ClientUrlFactory';
import { OrderDetails } from './OrderDetails';

export interface IAppData {
  isAuthorized: boolean;
  countyFips: string;
  errorMessage: string;
  finalizable: boolean;
  token?: string;
  order: OrderDetails;
  title: string;
}

export class AppService implements IAppData {
  public isAuthorized = false;
  public countyFips = '';
  public errorMessage = '';
  public finalizable = false;
  public order = new OrderDetails();
  public title = 'Create';
  public token?: string;
  public saveAttempted = false;

  constructor() {
    makeObservable(this, {
      isAuthorized: observable,
      countyFips: observable,
      errorMessage: observable,
      finalizable: observable,
      order: observable,
      title: observable,
      token: observable,
      saveAttempted: observable,
      setCountyFips: action,
      setErrorMessage: action,
      setFinalizable: action,
      setOrderData: action,
      setTitle: action,
      setSaveAttempted: action,
    });

    runInAction(() => {
      this.token = CookiesStatic.get('spruce_jwt');
    });
  }

  public setCountyFips(newVal: string) {
    this.countyFips = newVal;
  }
  public setErrorMessage(newVal: string) {
    this.errorMessage = newVal;
  }
  public setFinalizable(newVal: boolean) {
    this.finalizable = newVal;
  }
  public setOrderData(newVal: OrderDetails) {
    this.order = newVal;
  }
  public setTitle(newVal: string) {
    this.title = newVal;
  }
  public setSaveAttempted(newVal: boolean) {
    this.saveAttempted = newVal;
  }

  public async signOut() {
    window.location.href = clientUrls.urlFor.logoutAuth0(eAccessControlLogoutReason.STANDARD);
  }
}
